<template>
  <div>
    <router-link :to="speakerLink">
      <div class="mx-auto mt-4">
        <img
          class="inline-block h-24 w-24 rounded-full text-white shadow-solid"
          :src="speakerImage"
          alt=""
        />
        <div class="text-gray-700  font-semibold mt-2 text-xl">
          <span>{{ speaker.name }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "SpeakerSideBar",
  props: {
    speaker: {
      type: Object,
      required: true
    }
  },
  computed: {
    speakerImage() {
      console.log(this.speaker);
      return sanityImageBuilder
        .image(this.speaker.portrait)
        .width(200)
        .height(200)
        .url();
    },
    speakerLink() {
      return `/speaker/${this.speaker._id}`;
    }
  }
};
</script>

<style scoped></style>
